<template>
  <div
    class="options-container rounded mb-3 px-4 py-3"
    @keyup.enter="$emit('search')"
  >
    <div class="d-flex flex-wrap flex-sm-nowrap">
      <div class="d-flex flex-column w-100 mr-0 mr-sm-2 mb-3 mb-sm-0">
        <slot />
      </div>
      <ShowAdvancedButton
        :active="showAdvanced"
        @click="showAdvanced = !showAdvanced"
        v-if="advancedSearch"
      />
    </div>
    <el-collapse-transition v-if="advancedSearch">
      <div class="advanced-search-container" v-if="showAdvanced">
        <hr />
        <slot name="advanced-search" />
        <div class="d-flex justify-content-end">
          <el-button @click="$emit('reset')" class="outline-button">
            {{ $t("sections.common.search.resetButton") }}
          </el-button>
          <el-button
            type="primary"
            @click="$emit('search')"
            :disabled="disableSearch"
          >
            {{ $t("sections.common.search.searchButton") }}
            <font-awesome-icon icon="fa-regular fa-magnifying-glass" class="ml-2" />
          </el-button>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import ShowAdvancedButton from '@/components/ui/buttons/ShowAdvancedButton.vue';

export default {
  name: 'SearchContainer',
  props: {
    advancedSearch: {
      type: Boolean,
      default: false,
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShowAdvancedButton,
  },
  data() {
    return {
      showAdvanced: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.options-container {
  background: var(--card-secondary-background);
  border: 1px solid var(--primary);

  --grid-gutter-width: 10px;
}
</style>
